import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import Constants from '../../constants';

const initialState = {
    systemTemplateLoader: false,
    sysmtemJourneyLoader: false,
};

export const challengesJSON = createAsyncThunk(
    'system/challengeJSON',
    async (params) => {
        try {
            const response = await fetch(Constants.Api.commonUrl+'ChallengeJSON?Token='+params.token+'&ChallengeID='+params.challengeId, {
                method: 'get'
            });
            const data = await response.json();
            return data
        } catch (err) {
            return err;
        }
    }
)

export const notificationJSON = createAsyncThunk(
    'system/notificationJSON', 
    async (params) => {
        try {
            const response = await fetch(Constants.Api.commonUrl+'NotificationsJSON?Token='+params.token+'&NotificationID='+params.notificationId, {
                method: 'get'
            });
            const data = await response.json();
            return data
        } catch (err) {
            return err;
        }
    }
)

export const mediaJSON = createAsyncThunk(
    'system/mediaJSON',
    async (params) => {
        try {
            const response = await fetch(Constants.Api.commonUrl+'MediaJSON?Token='+params.token+'&MediaID='+params.mediaId, {
                method: 'get'
            });
            const data = await response.json();
            return data;
        } catch (err) {
            return err;
        }
    }
)

export const tableColumnLookupJSON = createAsyncThunk(
    'system/TableColumnLookupJSON', 
    async (params) => {
        try {
            const response = await fetch(Constants.Api.commonUrl+'TableColumnLookupJSON?Token='+params.token+'&TableName='+params.tableName+'&ColumnName='+params.columnName+'&Language='+params.language, {
                method: 'get'
            });
            const data = await response.json();
            return data;
        } catch (err) {
            return err;
        }
    }
)

export const AddUpdateJourneyJSON = createAsyncThunk(
    'system/AddUpdateJourneyJSON',
    async (params) => {
        try {
            const response = await fetch(Constants.Api.commonUrl+'AddUpdateJourneyJSON?Token='+params.token+'&TemplateID='+params.templateId+'&GoalID='+params.goalId+'&Active='+params.active, {
                method: 'get'
            });
            const data = await response.json();
            return data;
        } catch (err) {
            return err;
        }
    }
)

const systemTemplateSlice = createSlice({
    name: 'systemTemplate',
    initialState,
    reducers: {

    },
    extraReducers: {
        [challengesJSON.pending] : (state, action) => {
            state.systemTemplateLoader = true
        },
        [challengesJSON.fulfilled] : (state, action) => {
            state.systemTemplateLoader = false
        },
        [challengesJSON.rejected] : (state, action) => {
            state.systemTemplateLoader = false
        },
        [notificationJSON.pending] : (state, action) => {
            state.systemTemplateLoader = true
        },
        [notificationJSON.fulfilled] : (state, action) => {
            state.systemTemplateLoader = false
        },
        [notificationJSON.rejected] : (state, action) => {
            state.systemTemplateLoader = false
        },
        [mediaJSON.pending]: (state, action) => {
            state.systemTemplateLoader = true
        },
        [mediaJSON.fulfilled] : (state, action) => {
            state.systemTemplateLoader = false
        },
        [mediaJSON.rejected] : (state, action) => {
            state.systemTemplateLoader = false
        },

        [tableColumnLookupJSON.pending] : (state, action) => {
            state.sysmtemJourneyLoader = true
        },
        [tableColumnLookupJSON.fulfilled] : (state, action) => {
            state.sysmtemJourneyLoader = false
        },
        [tableColumnLookupJSON.rejected] : (state, action) => {
            state.sysmtemJourneyLoader = false
        },

        [AddUpdateJourneyJSON.pending] : (state, action) => {

        },
        [AddUpdateJourneyJSON.fulfilled] : (state, action) => {

        },
        [AddUpdateJourneyJSON.rejected] : (state, action) => {

        }
    }
})

export default systemTemplateSlice.reducer